// @flow
import type { UserState } from '../user'
import type { User } from '../../../types/user'

export default {
  user: (state: UserState): ?User => {
    return state.user
  },
  types: (state: UserState): string[] => {
    if (state.user && state.user.types) {
      return state.user.types.map(type => type.type)
    }

    return []
  },
  customerNumber: (state: UserState) => {
    if (state.user && state.user.profile && state.user.profile.customerNumber) {
      return state.user.profile.customerNumber.number
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user/getters.js